import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GoogleTranslateService {
  private scriptLoaded = false;

  constructor() {}

  // initTranslate(containerId: string, pageLang: string = 'en') {
  //   if (this.scriptLoaded) {
  //     this.renderWidget(containerId, pageLang);
  //     return;
  //   }

  //   // Attach global callback so Google can call it
  //   (window as any).googleTranslateElementInit = () => {
  //     this.renderWidget(containerId, pageLang);
  //   };

  //   // Dynamically inject script
  //   const script = document.createElement('script');
  //   script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
  //   document.body.appendChild(script);

  //   this.scriptLoaded = true;
  // }

  initTranslate(containerId: string, pageLang: string = 'en') {
    if (this.scriptLoaded) return;

    (window as any).googleTranslateElementInit = () => {
      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: pageLang,
          autoDisplay: false,
        },
        containerId
      );
    };

    const script = document.createElement('script');
    script.src =
      'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.body.appendChild(script);

    this.scriptLoaded = true;
  }
  private renderWidget(containerId: string, pageLang: string) {
    if ((window as any).google && (window as any).google.translate) {
      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: pageLang,
          layout: (window as any).google.translate.TranslateElement.InlineLayout
            .SIMPLE,
        },
        containerId
      );
    }
  }
}
